<template>
  <el-dialog
    title="选择仓库"
    :visible.sync="dialogVisible"
    width="70%"
    append-to-body
    :before-close="handleClose"
  >
    <div style="padding-bottom: 40px;">
      <el-form :inline="true">
        <el-form-item label="门店名" label-width="80px">
          <el-input v-model="searchForm.name" clearable placeholder="门店名">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="getList()">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%;"
        border
        stripe
      >
        <el-table-column
          label="门店名称"
          align="center"
          prop="name"
          width="200"
        />
        <el-table-column
          label="门店二维码"
          align="center"
          prop="address"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-image
              style="width: 60px; height: 60px;"
              :src="row.codeImg"
              :preview-src-list="[row.codeImg]"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column
          label="门店位置"
          align="center"
          prop="address"
          min-width="200"
        >
          <template slot-scope="{ row }">
            {{ row.province || "" }}-{{ row.city || "" }}-{{ row.county || ""
            }}<br />
            {{ row.address || "" }}
          </template>
        </el-table-column>

        <el-table-column
          label="门店管理员"
          align="center"
          prop="userName"
          width="160"
        >
          <template slot-scope="{ row }">
            {{ row.userName || "" }} - {{ row.userPhone || "" }}
          </template></el-table-column
        >
        <el-table-column
          label="门店联系方式"
          align="center"
          prop="phone"
          width="160"
        />

        <el-table-column
          label="操作"
          align="center"
          prop="icon"
          fixed="right"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="primary" plain @click="select(scope.row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="searchForm.pageNo"
        :page-size="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      total: 0,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    init() {
      this.dialogVisible = true;
      this.searchForm = {
        pageNo: 1,
        pageSize: 10,
        name: null,
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
    select(row) {
      this.$emit("bark", row);
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    getList() {
      this.$axios
        .post("/admin/store/getStoreList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.cus_area {
  margin: 10px;
}
</style>
